import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchSinglePackageWithIdentifier } from "../api/package.api";

interface usePackageWithIdentifierProps {
  identifier?: string;
  companyId?: number;
}

const usePackageWithIdentifier = ({
  identifier,
  companyId,
}: usePackageWithIdentifierProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const {
    data: packageData,
    error: packageError,
    isLoading: isLoadingPackage,
    isSuccess: isSuccessPackage,
  } = useQuery({
    queryKey: ["packages", identifier],
    queryFn: () =>
      fetchSinglePackageWithIdentifier(
        bearerToken as string,
        companyId as number,
        identifier as string
      ),
    enabled: !!identifier && !!companyId,
  });

  return {
    packageData,
    packageError,
    isLoadingPackage,
  };
};

export default usePackageWithIdentifier;
